// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","571":"b637e9a5","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"789201cd2cccdaeb8d10","571":"9fca9a44c5573cf0e110","678":"6a61c31b623b98e9580a","883":"c0749d875e916d06e57b"}[chunkId] + ".js";
};